import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { MaskLines } from "./motion";

export const PageHero = ({ eyebrow, title, img, alt }) => {
  const reduce = useReducedMotion();
  return (
    <section data-testid="page-hero" className="grain relative isolate overflow-hidden bg-[color:var(--ngp-ink)] text-white">
      <motion.img src={img} alt={alt} className="absolute inset-0 -z-10 h-full w-full object-cover"
        initial={reduce ? false : { scale: 1.15, opacity: 0.3 }} animate={{ scale: 1.02, opacity: 0.55 }} transition={{ duration: 1.6, ease: [0.2, 0.7, 0.2, 1] }} />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#1d1d1b] via-[#1d1d1b]/70 to-[#1d1d1b]/50" />
      <div className="mx-auto flex min-h-[62svh] max-w-[1440px] flex-col justify-end px-5 pb-14 pt-36 sm:px-8 lg:min-h-[68vh] lg:px-12 lg:pb-20">
        <nav aria-label="Breadcrumb" className="mb-8 flex items-center gap-1.5 text-xs text-white/70">
          <Link to="/" className="hover:text-white" data-testid="breadcrumb-home">Home</Link><ChevronRight size={12} aria-hidden="true" /><span className="text-white">{eyebrow}</span>
        </nav>
        <p className="eyebrow mb-5 flex items-center gap-3 text-[color:var(--ngp-teal)]"><span className="h-px w-8 bg-current" />{eyebrow}</p>
        <h1 data-testid="page-title" className="font-display max-w-5xl text-5xl font-semibold leading-[0.95] tracking-[-0.03em] sm:text-6xl lg:text-8xl">
          <MaskLines lines={[title]} delay={0.25} />
        </h1>
      </div>
    </section>
  );
};
